import * as Constants from './constants'

const initialState = {
  addTestLoading: false,
  getTestLoading: false,
  getTest: {}
}

const reducer = function questionReducer (state = initialState, action) {
  switch (action.type) {
    case Constants.ADD_REQUEST:
      return {
        addTestLoading: true,
        messages: [{
          body: 'Adding test...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.ADD_SUCCESS:
      return {
        addTest: action.result.meta,
        addTestLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.ADD_ERROR:
      return {
        addTestLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.ADD_CLEAR:
      return {
        addTestLoading: false,
        messages: [],
        errors: [],
      }

    case Constants.GET_REQUEST:
      return {
        getTestLoading: true,
        messages: [{
          body: 'Getting Test...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.GET_SUCCESS:
      return {
        getTest: action.result,
        getTestLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.GET_ERROR:
      return {
        getTestLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer
